import { type ClassNameValue, extendTailwindMerge } from "tailwind-merge";

/*
  tailwind-merge resolves `text-*` by looking the value up in its own list of
  font sizes, and calls anything it does not recognise a colour. Our extra
  sizes (index.css) are not in that list, so `cn("text-foreground-muted",
  "text-tiny")` used to drop the colour as the loser of a colour-vs-colour
  conflict. Naming them here puts them back in the size group, where a size
  overrides a size and leaves the colour alone.
*/
const twMerge = extendTailwindMerge<"border-gradient" | "border-holo">({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "xxs",
            "tiny",
            "xtiny",
            "xxtiny",
            // The design-system type ramp (styles/design-system.css).
            "h1",
            "h2",
            "h3",
            "h4",
            "body-lg",
            "body",
            "small",
          ],
        },
      ],
      // Ring utilities (styles/*.css), not border colours: own groups, so they
      // stack instead of dropping each other.
      "border-gradient": ["border-gradient"],
      "border-holo": ["border-holo", "border-holo-orbit"],
    },
  },
});

export function cn(...inputs: ClassNameValue[]) {
  return twMerge(inputs);
}
